import { RefreshCw, Shield, Target } from 'lucide-react';

import { SecondaryCTA } from '../components/SecondaryCTA';
import { RoutingDiagram } from '../components/RoutingDiagram';
import { SectionWrapper } from '../components/SectionWrapper';

import styles from './AITeaserSection.module.css';

const trustPoints = [
  {
    body: 'Queries anonymized before reaching any model provider.',
    icon: Shield,
    title: 'Privacy-first',
  },
  {
    body: 'Swap between frontier models without new contracts.',
    icon: RefreshCw,
    title: 'Model-agnostic',
  },
  {
    body: 'The AI guides students rather than solving their homework.',
    icon: Target,
    title: 'Course-scoped',
  },
] as const;

export function AITeaserSection() {
  return (
    <SectionWrapper
      background="navy"
      contentClassName={styles.sectionContent}
      data-testid="marketing-section-ai-teaser"
    >
      <div className={styles.section}>
        <div className={styles.intro}>
          <h2 className={styles.title}>AI that institutions can actually trust.</h2>
          <p className={styles.subhead}>
            Model-agnostic. Anonymized. Pedagogy-first. Validated in
            independent research to actually improve learning — especially for
            students less likely to ask a TA for help.
          </p>
        </div>

        <RoutingDiagram />

        <div className={styles.points}>
          {trustPoints.map(({ body, icon: Icon, title }) => (
            <article className={styles.point} key={title}>
              <span aria-hidden="true" className={styles.pointIcon}>
                <Icon size={20} />
              </span>
              <h3 className={styles.pointTitle}>{title}</h3>
              <p className={styles.pointBody}>{body}</p>
            </article>
          ))}
        </div>

        <div className={styles.actions}>
          <SecondaryCTA
            className={styles.cta}
            href="/ai"
            label="Read Kudu's full AI position"
          />
        </div>
      </div>
    </SectionWrapper>
  );
}
